import { canonicalizeJson } from "./canonical-json";
import { canonicalizeLuminaireSourceUrl } from "./catalog-url";
import { computeLuminaireSpecContentDigest, LuminaireSpecV1Schema, type LuminaireSpecV1 } from "./schema";

export class ReviewedLuminaireSpecError extends Error {
  constructor(readonly kind: "invalid_specification" | "unreviewed_specification" | "digest_mismatch") {
    super(kind);
    this.name = "ReviewedLuminaireSpecError";
  }
}

/** Validate an already reviewed contract without modifying, approving or re-signing it. */
export async function verifyReviewedLuminaireSpec(input: unknown): Promise<LuminaireSpecV1> {
  let spec: LuminaireSpecV1;
  try {
    spec = LuminaireSpecV1Schema.parse(input);
    if (canonicalizeJson(spec) !== canonicalizeJson(input)) throw new Error("Transformed contract");
    canonicalizeLuminaireSourceUrl(spec.product.sourceUrl);
    if ([spec.productId, spec.revisionId].some((id) => /[\u0000-\u001f\u007f]/u.test(id))) {
      throw new Error("Invalid publication identity");
    }
    // The supported delivery and ingestion contract requires content-addressed PDFs.
    if (!/^sha256:[a-f0-9]{64}$/.test(spec.sourcePdfArtifactId)) throw new Error("Invalid source artifact");
  } catch {
    throw new ReviewedLuminaireSpecError("invalid_specification");
  }
  if (spec.review.status !== "reviewed") throw new ReviewedLuminaireSpecError("unreviewed_specification");
  if (await computeLuminaireSpecContentDigest(spec) !== spec.integrity.contentDigest) {
    throw new ReviewedLuminaireSpecError("digest_mismatch");
  }
  return spec;
}
